module.exports = __webpack_public_path__ + "993f1315910fd6ae5897ccc05c1bf901.png";